/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiIncrementalityFinancialSummaryFromJSON, ApiIncrementalityFinancialSummaryToJSON, } from './ApiIncrementalityFinancialSummary';
import { ApiIncrementalityPrimaryMetricResultFromJSON, ApiIncrementalityPrimaryMetricResultToJSON, } from './ApiIncrementalityPrimaryMetricResult';
export function ApiIncrementalityTestResultFromJSON(json) {
    return ApiIncrementalityTestResultFromJSONTyped(json, false);
}
export function ApiIncrementalityTestResultFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'financialSummary': !exists(json, 'financialSummary') ? undefined : ApiIncrementalityFinancialSummaryFromJSON(json['financialSummary']),
        'primaryMetric': !exists(json, 'primaryMetric') ? undefined : ApiIncrementalityPrimaryMetricResultFromJSON(json['primaryMetric']),
        'supportingMetrics': !exists(json, 'supportingMetrics') ? undefined : (json['supportingMetrics'].map(ApiIncrementalityPrimaryMetricResultFromJSON)),
    };
}
export function ApiIncrementalityTestResultToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'financialSummary': ApiIncrementalityFinancialSummaryToJSON(value.financialSummary),
        'primaryMetric': ApiIncrementalityPrimaryMetricResultToJSON(value.primaryMetric),
        'supportingMetrics': value.supportingMetrics === undefined ? undefined : (value.supportingMetrics.map(ApiIncrementalityPrimaryMetricResultToJSON)),
    };
}
